import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      portfolioScore: {
        settingRisk: 'Setting Risk trend',
        settingPerformance: 'Setting Performance trend',
        here: 'here.',
        PORTFOLIO: 'Portfolio',
        MEDIAN_SCORE: 'Median',
        INTERQUARTILE_RANGE: 'Interquartile range',
        trendLine: 'Trendline',
        median: 'Median',
        firstQuartile: 'First quartile',
        thirdQuartile: 'Third quartile',
        UP: 'Up',
        DOWN: 'Down',
        UNDEFINED: 'Undefined',
        total: 'Total',
        anyRisk: 'Any Risk',
        anyPotential: 'Any Potential',
        add: 'Add',
        or: 'or',
        undetermined: 'Undetermined',
        score: 'Score',
        creditRisk: 'Corporate Risk Score',
        performance: 'Performance Score',
        totalCompanies: 'Total Companies',
        highestCredit: 'Highest Credit Risk Companies',
        newHighestCredit: 'New Highest Credit Risk Companies',
        highestGrowth: 'Highest Growth Potential Companies',
        newHighestGrowth: 'New Highest Growth Potential Companies',
        riskTrend: 'Risk Trend',
        textNoteRiskTrend:
          'The number of companies that have moved into different levels of risk.',
        edit: 'Edit',
        previousLevel: 'Previous Level',
        trend: 'Trend',
        currentLevel: 'Current Level',
        numberOfCompanies: 'Number of Companies',
        percentOfTotal: '% of Total Companies',
        performanceTrend: 'Performance Trend',
        textNotePerformanceTrend:
          'The number of companies that have moved into different levels of growth potential.',
        portfolioDistributionByCredit:
          'Portfolio Distribution By Corporate Risk',
        textNotePortfolioDistributionByCredit:
          'The number of companies in different levels of risk.',
        riskLevel: 'Risk Levels',
        portfolioDistributionByGrowth:
          'Portfolio Distribution By Growth Potential',
        textNotePortfolioDistributionByGrowth:
          'The number of companies with different levels of growth potential.',
        performanceLevel: 'Performance Levels',
        titleCompaniesByRisk: 'Top 10 Companies By Risk Trends',
        highestCreditRisk: 'Highest Corporate Risk Level',
        hightTextNoteCompanies:
          'Companies with the lowest Corporate Risk Score.',
        biggestScoreChanges: 'Biggest Score Changes',
        biggestCompaniesTextNote:
          'Companies with the biggest Corporate Risk Score change.',
        largestDecline: 'Largest Decline',
        companiesWithLargestText:
          'Companies with the largest decline in Corporate Risk Score.',
        titleCompaniesByPerformance: 'Top 10 Companies By Growth Potential',
        highestGrowthByPer: 'Highest Growth Potential',
        companiesHighestPerformance:
          'Companies with the highest Performance score.',
        companiesBiggestPer:
          'Companies with the biggest Performance Score changes.',
        companiesLargestByPer:
          'Companies with the largest decline in Performance Score.',
        titleCredit: 'Corporate Risk Score Trend by Portfolio',
        titlePerformance: 'Performance Score Trend by Portfolio',
        viewBy: 'View by',
        chart: 'Chart',
        table: 'Table',
        textNoteCredit:
          'Median corporate risk score for companies in the selected portfolios over the past 5 years',
        textNotePerformance:
          'Median performance score for companies in the selected portfolios over the past 5 years',
        filteredPortfolio: 'Filtered portfolio',
        portfolioDecline: 'Largest decline score in recent years',
        portfolioLowest: 'Lowest current score portfolio',
        namePortById: {
          1: 'Filtered portfolio',
          2: 'Largest decline score in recent years',
          3: 'Lowest current score portfolio',
        },
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      portfolioScore: {
        settingRisk: 'Cài đặt Xu hướng rủi ro',
        settingPerformance: 'Cài đặt Xu hướng tiềm năng tăng trưởng',
        here: 'tại đây.',
        PORTFOLIO: 'Danh mục',
        MEDIAN_SCORE: 'Trung vị',
        INTERQUARTILE_RANGE: 'Khoảng tứ phân vị',
        trendLine: 'Xu Hướng',
        median: 'Trung vị',
        firstQuartile: 'Tứ phân vị thứ nhất',
        thirdQuartile: 'Tứ phân vị thứ 3',
        UP: 'Tăng',
        DOWN: 'Giảm',
        UNDEFINED: 'Không xác định',
        total: 'Tổng',
        anyRisk: 'Mức rủi ro khác',
        anyPotential: 'Mức tăng trưởng khác',
        add: 'Thêm',
        or: 'hoặc',
        undetermined: 'Không xác định',
        score: 'Điểm',
        creditRisk: 'Điểm rủi ro doanh nghiệp',
        performance: 'Điểm triển vọng tăng trưởng',
        totalCompanies: 'Số lượng công ty',
        highestCredit: 'Công ty có rủi ro tín dụng cao',
        newHighestCredit: 'Công ty có rủi ro tín dụng cao mới',
        highestGrowth: 'Công ty có triển vọng tăng trưởng cao',
        newHighestGrowth: 'Công ty có triển vọng tăng trưởng cao mới',
        riskTrend: 'Xu Hướng Rủi Ro',
        textNoteRiskTrend:
          'Số lượng công ty có sự thay đổi mức rủi ro tín dụng',
        edit: 'Sửa',
        previousLevel: 'Mức Điểm Kỳ Trước',
        trend: 'Xu Hướng',
        currentLevel: 'Mức Điểm Kỳ Hiện Tại',
        numberOfCompanies: 'Số Lượng Công Ty',
        percentOfTotal: '% Tỷ Trọng',
        performanceTrend: 'Xu Hướng Triển Vọng Tăng Trưởng',
        textNotePerformanceTrend:
          'Số lượng công ty có sự thay đổi mức triển vọng tăng trưởng',
        portfolioDistributionByCredit: 'Phân Bổ Danh Mục Theo Mức Rủi Ro',
        textNotePortfolioDistributionByCredit:
          'Số lượng công ty ở các mức rủi ro xác định',
        riskLevel: 'Mức Độ Rủi Ro',
        portfolioDistributionByGrowth:
          'Phân Bổ Danh Mục Theo Triển Vọng Tăng Trưởng',
        textNotePortfolioDistributionByGrowth:
          'Số lượng công ty ở các mức triển vọng tăng trưởng xác định',
        performanceLevel: 'Mức triển vọng tăng trưởng',
        titleCompaniesByRisk: 'Top 10 Công Ty Theo Các Tiêu Chí Rủi Ro',
        highestCreditRisk: 'Mức rủi ro doanh nghiệp cao nhất',
        hightTextNoteCompanies:
          'Công ty có điểm rủi ro doanh nghiệp thấp nhất.',
        biggestScoreChanges: 'Mức thay đổi điểm lớn nhất',
        biggestCompaniesTextNote:
          'Công ty có biến động điểm rủi ro doanh nghiệp lớn nhất.',
        largestDecline: 'Mức giảm điểm lớn nhất',
        companiesWithLargestText:
          'Công ty có mức giảm điểm rủi ro doanh nghiệp lớn nhất.',
        titleCompaniesByPerformance:
          'Top 10 Công Ty Theo Các Tiêu Chí Triển Vọng Tăng Trưởng',
        highestGrowthByPer: 'Triển vọng tăng trưởng cao nhất',
        companiesHighestPerformance:
          'Công ty có điểm triển vọng tăng trưởng cao nhất.',
        companiesBiggestPer:
          'Công ty có điểm triển vọng tăng trưởng thay đổi lớn nhất.',
        companiesLargestByPer:
          'Công ty có mức giảm điểm triển vọng tăng trưởng lớn nhất.',
        titleCredit: 'Xu hướng điểm rủi ro doanh nghiệp theo danh mục',
        titlePerformance: 'Xu hướng triển vọng tăng trưởng theo danh mục',
        viewBy: 'Xem theo',
        chart: 'Biểu đồ',
        table: 'Bảng',
        textNoteCredit:
          'Trung vị điểm rủi ro doanh nghiệp của các công ty trong các danh mục được chọn',
        textNotePerformance:
          'Trung vị điểm triển vọng tăng trưởng của các công ty trong các danh mục được chọn',
        filteredPortfolio: 'Danh mục phân tích',
        portfolioDecline: 'Danh mục giảm nhiều điểm gần đây',
        portfolioLowest: 'Danh mục có điểm kỳ hiện tại thấp nhất',
        namePortById: {
          1: 'Danh mục phân tích',
          2: 'Danh mục giảm nhiều điểm gần đây',
          3: 'Danh mục có điểm kỳ hiện tại thấp nhất',
        },
      },
    },
  }),
)
